export default __webpack_public_path__ + "static/media/doc.4d446b621d6e740d55e3a346da883e59.svg";